type Props = {
  amount?: string;
};

const defaultData: Props = {
  amount: "",
};

export class RechargeWalletModel {
  amount?: string;

  constructor(data: Props = defaultData) {
    this.amount = data.amount || "";
  }
}
